import React, { useState } from "react";
import classes from "./BecomeAnInvestorMobile.module.css";
import { Col, Container, Row } from "react-bootstrap";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { Input } from "../../../stories/Input/Input";
import { Checkbox } from "../../../stories/Checkbox/Checkbox";
import { MobileFooter } from "../../../stories/MobileFooter/MobileFooter";
import { MobileHeader } from "../../../stories/MobileHeader/MobileHeader";
import { Button } from "../../../stories/Button/Button";
import {
  logo,
  quotationMark,
  corporateOverview,
  ourAchievements,
  instantMessaging,
  HeadingBg,
} from "../../../constant/imagePath";

const BecomeAnInvestorMobile = () => {
  const [email, setemail] = useState("");
  const [check, setcheck] = useState(["Presentations", "Event"]);

  const acheivements = [
    {
      title: "1000",
      desc: "All of our coaches have extensive coaching experience and are required to pass rigorous background checks.",
    },
    {
      title: "500",
      desc: "Every coaching session can be booked in minutes through Lytesnap and all financial transactions are processed online.",
    },
    {
      title: "13,492",
      desc: "We are committed to helping you find the right coach, and we back that up with our 100% money-back guarantee.",
    },
  ];
  return (
    <div>
      <Container fluid className="p-0">
        <Row className="g-0">
          <Col sm={12}>
            <div className={classes.headSection}>
              <Row className="g-0">
                <Col sm={12}>
                  <MobileHeader isLogo={true} logo={logo} isAvatar={true} />
                </Col>
                <Col sm={12}>
                  <h3
                    className={classes.headSectionText}
                    style={{ color: Colors.white, ...Fonts.h3 }}
                  >
                    <span>Become an </span>
                    <span className={classes.headingBg}>
                      &nbsp;&nbsp;investor&nbsp;&nbsp;&nbsp;
                      <img src={HeadingBg} />
                    </span>
                  </h3>
                </Col>
                <Col sm={12}>
                  <div className={classes.textWithBtn}>
                    <p
                      style={{
                        ...Fonts.p1,
                        fontSize: "14px",
                        color: Colors.white,
                      }}
                    >
                      We are looking for experienced individuals to join our
                      national team of talented sports coaches.
                    </p>
                    <Button size={"Large"} primary={true}>
                      Apply now
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>

          <Col
            sm={12}
            style={{ backgroundColor: Colors.neutralShadesOfWhiteSmoke }}
            className={[classes.colpadding].join(" ")}
          >
            <h2
              style={{
                ...Fonts.h2,
                color: Colors.neutralShadesOfNero,
                fontSize: "26px",
                lineHeight: "32px",
              }}
              className={[classes.mb48].join(" ")}
            >
              Our{" "}
              <span className={classes.headingBg}>
                mission
                <img src={HeadingBg} alt="" />
              </span>
            </h2>

            <div className={[classes.mb16].join(" ")}>
              <img src={quotationMark} alt="" />
            </div>

            <div>
              <p
                style={{
                  ...Fonts.h4,
                  fontSize: "26px",
                  color: Colors.neutralShadesOfNero,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-1%",
                }}
                className={[classes.mb24].join(" ")}
              >
                I am very fond of the idea of CoachUp and enthusiastic about it.
                Anytime you can have extra training, guidance, and help in
                something that you enjoy doing, and in which you have shown the
                capacity to improve, its a great thing.
              </p>
              <div className={classes.sec2NameAndDesignation}>
                <p
                  style={{
                    ...Fonts.h5,
                    color: Colors.neutralShadesOfNero,
                    fontSize: "19px",
                    lineHeight: "24px",
                    marginBottom: "8px",
                    letterSpacing: "-1%",
                  }}
                >
                  Jason Ngo
                </p>
                <p
                  style={{
                    ...Fonts.p1,
                    color: Colors.neutralShadesOfDimGray,
                    fontSize: "14px",
                  }}
                >
                  CEO and co-founder, Lytesnap
                </p>
              </div>
            </div>
          </Col>
          <Col sm={12} className={[classes.colpadding].join(" ")}>
            <h2
              style={{
                ...Fonts.h2,
                color: Colors.neutralShadesOfNero,
                fontSize: "26px",
                lineHeight: "32px",
              }}
              className={[classes.mb24].join(" ")}
            >
              Corporate overview
            </h2>
            <p
              style={{
                ...Fonts.p1,
                color: Colors.neutralShadesOfDimGray,
              }}
              className={[classes.mb28].join(" ")}
            >
              Recruit Look regularly talks about the things each potential
              recruit needs to accomplish to maximize their chances of landing
              an athletic scholarship. Please make sure to avoid these
              mistakes…mostly caused from massive misinformation out there. Keep
              in mind, sometimes what you don’t say is just as important as what
              you do.
            </p>

            <div className={[classes.sec2div].join(" ")}>
              <img src={corporateOverview} alt="corporateOverview" />
            </div>
          </Col>

          <Col md={12} className={[classes.ourAchievementContainer].join(" ")}>
            <Col sm={12} className={[classes.sec4MainContainer].join(" ")}>
              <div className={[classes.sec4InnerContainer].join(" ")}>
                <Col md={12}>
                  <p
                    style={{
                      ...Fonts.h2,
                      color: Colors.white,
                      fontSize: "26px",
                      lineHeight: "32px",
                    }}
                  >
                    Our{" "}
                    <span className={classes.headingBg}>
                      achievements
                      <img src={HeadingBg} alt="" />
                    </span>
                  </p>
                </Col>
                <Row className={`g-0 ${[classes.sec4Body].join(" ")}`}>
                  {acheivements.map((item, index) => {
                    return (
                      <Col sm={12} className={[classes.mb24, "p-0"].join(" ")}>
                        <div className={classes.seperator} key={index}>
                          <p
                            className={[classes.mb16].join(" ")}
                            style={{
                              ...Fonts.h3,
                              color: Colors.white,
                              fontSize: "24px",
                              lineHeight: "32px",
                            }}
                          >
                            {item.title}
                          </p>
                          <p
                            style={{
                              ...Fonts.p1,
                              color: Colors.white,
                              fontSize: "14px",
                            }}
                          >
                            {item.desc}
                          </p>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </Col>
          </Col>

          <Col
            sm={12}
            className={[classes.colpadding].join(" ")}
            style={{ backgroundColor: Colors.neutralShadesOfWhiteSmoke }}
          >
            <p
              className={[classes.mb40].join(" ")}
              style={{
                ...Fonts.h2,
                color: Colors.neutralShadesOfNero,
                fontSize: "26px",
                lineHeight: "32px",
              }}
            >
              Email Alerts and Contact Info
            </p>

            <Container
              style={{ backgroundColor: Colors.white }}
              className={[classes.formdiv, classes.mb40].join(" ")}
            >
              <div className={[classes.mb26].join(" ")}>
                <Input
                  state={email}
                  setter={setemail}
                  type="email"
                  placeholder="Your Email"
                />
              </div>
              <div className={[classes.mb16].join(" ")}>
                <Checkbox
                  value={check}
                  setValue={setcheck}
                  label="Presentations"
                />
              </div>
              <div className={[classes.mb32].join(" ")}>
                <Checkbox value={check} setValue={setcheck} label="Event" />
              </div>
              <Button
                primary={true}
                customStyle={{
                  width: "100%",
                  fontSize: "16px",
                  lineHeight: "32px",
                  height: "56px",
                }}
              >
                Submit
              </Button>
            </Container>

            <div className={[classes.commentimg, classes.mb24].join(" ")}>
              <img src={instantMessaging} alt="" />
            </div>

            <p
              style={{
                ...Fonts.p1,
                color: Colors.neutralShadesOfNero,
                fontSize: "14px",
                lineHeight: "24px",
              }}
              className={[classes.mb32].join(" ")}
            >
              Questions for the Investor Relations department can be emailed to{" "}
              <a
                className={[classes.textdecor].join(" ")}
                style={{ color: Colors.mainBlue }}
                href="mailto:lytesnap@com"
              >
                lytesnap@com
              </a>{" "}
              or submitted by clicking on the button below.
            </p>

            <Button
              primary={false}
              customStyle={{
                width: "100%",
                fontSize: "16px",
                lineHeight: "32px",
                height: "56px",
              }}
            >
              Contact us
            </Button>
          </Col>

          <Col sm={12}>
            <MobileFooter />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default BecomeAnInvestorMobile;
